export const state = () => ({
    settings: null,
})

export const mutations = {
    SET_SETTINGS(state, settings) {
        state.settings = settings
    },
}

export const getters = {
    SETTINGS: (state) => state.settings,
}

export const actions = {
    async nuxtServerInit({ commit }, { $axios }) {
        try {
            // On the SSR critical path: bound it so a slow/unavailable CRM (behind
            // /config) can never block the page render. On timeout/error we fall back
            // to empty settings and render immediately — the backend keeps this cache
            // warm, so 800ms is only ever hit in a genuine outage.
            const settings = await $axios.$get('config', { timeout: 800 })
            commit('SET_SETTINGS', settings || {})
        } catch (err) {
            console.error('[nuxtServerInit] Failed to load config:', err)
            commit('SET_SETTINGS', {})
        }
    },
}
